import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { mensajeProblema } from "./problem";

/**
 * El primitivo de datos de las pantallas de lista: envuelve `useQuery` para
 * cualquier endpoint de listado del ERP.
 *
 * - `clave`: la queryKey (identifica y cachea la consulta).
 * - `habilitada`: si falta el contexto necesario, `false` y no se llama.
 * - `llamada`: una función que hace el `api.GET(...)` tipado por la ruta; su
 *   `data` es `T[]`, así que la fila queda comprobada contra el contrato.
 *
 * Trata cualquier respuesta no-2xx como error. Devuelve el resultado de
 * react-query con `data` ya como `T[]`.
 */
export function useLista<T>(
  clave: readonly unknown[],
  habilitada: boolean,
  llamada: () => Promise<{ data?: T[]; error?: unknown; response: Response }>,
): UseQueryResult<T[]> {
  return useQuery({
    queryKey: clave,
    enabled: habilitada,
    queryFn: async () => {
      const { data, error, response } = await llamada();
      if ((error !== undefined && error !== null) || !response.ok) {
        throw new Error(mensajeProblema(error, response.status));
      }
      return data ?? [];
    },
  });
}
